import { on } from '@ember/modifier';
import type Owner from '@ember/owner';
import { tracked } from '@glimmer/tracking';

import { isAlive } from 'webapp/utils/common';

import type { Args as DemoButtonArgs } from 'webapp/components/common/demo-button';
import CommonDemoButtonComponent from 'webapp/components/common/demo-button';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args extends DemoButtonArgs {
	text?: string;
	delay?: number;
}

export default class CommonDemoFloatingButtonComponent<
	T extends Args,
> extends CommonDemoButtonComponent<T> {
	@tracked isShown = false;

	get text() {
		return this.args.text || 'Not ready to connect your source yet?';
	}

	constructor(owner: Owner, args: T) {
		super(owner, args);

		const delay = typeof args.delay !== 'undefined' ? args.delay : 15; // default is 15 seconds

		setTimeout(() => {
			if (isAlive(this)) {
				this.isShown = true;
			}
		}, delay * 1000);
	}
	<template>
		<div class="demo-floating-button {{if this.isShown 'show'}}">
			<div class="wrapper">
				<span>{{this.text}}</span>
				<a role="button" class="button" {{on "click" this.openDemoAccount}}>
					Try demo account
					<CommonUiIconComponent @name="External" @size="xs" />
				</a>
			</div>
		</div>
	</template>
}
